import { render, staticRenderFns } from "./Lesiurtabs.vue?vue&type=template&id=2f6ef914"
import script from "./Lesiurtabs.vue?vue&type=script&lang=js"
export * from "./Lesiurtabs.vue?vue&type=script&lang=js"
import style0 from "./Lesiurtabs.vue?vue&type=style&index=0&id=2f6ef914&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports